"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[638],{

/***/ 8106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
// EXTERNAL MODULE: ./core/hooks/index.ts + 4 modules
var hooks = __webpack_require__(6613);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
;// CONCATENATED MODULE: ./components/base/anchor/Anchor.tsx






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Anchor = function(_param, ref1) {
    var children = _param.children, href = _param.href, rest = _objectWithoutProperties(_param, [
        "children",
        "href"
    ]);
    var app = (0,contexts_app/* useApp */.qD)();
    var anchorRef = (0,react.useRef)(null);
    var refs = (0,hooks/* useCombineRefs */.he)(anchorRef, ref1);
    var url = utils/* path.app */.E.app(app.environment, href);
    (0,react.useEffect)(function() {
        if (window.location.pathname === url) {
            var ref;
            (ref = anchorRef.current) === null || ref === void 0 ? void 0 : ref.setAttribute('aria-current', 'page');
        }
    }, [
        url
    ]);
    if (url.indexOf('http') === 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("a", _objectSpread({
            ref: refs,
            href: url,
            target: "_blank",
            rel: "noreferrer noopener"
        }, rest, {
            children: children
        })));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", _objectSpread({
            ref: refs
        }, rest, {
            children: children
        }))
    }));
};
/* harmony default export */ var anchor_Anchor = (/*#__PURE__*/react.forwardRef(Anchor));

;// CONCATENATED MODULE: ./components/base/anchor/index.tsx


;// CONCATENATED MODULE: ./components/base/button/Button.tsx





function Button_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Button_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Button_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Button_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Button_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Button_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Button = function(_param, ref) {
    var anchor = _param.anchor, _appearance = _param.appearance, appearance = _appearance === void 0 ? 'default' : _appearance, autoFocus = _param.autoFocus, children = _param.children, className = _param.className, iconAfter = _param.iconAfter, iconBefore = _param.iconBefore, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _kind = _param.kind, kind = _kind === void 0 ? 'standard' : _kind, _shape = _param.shape, shape = _shape === void 0 ? 'pill' : _shape, _size = _param.size, size = _size === void 0 ? 'medium' : _size, testId = _param.testId, _type = _param.type, type = _type === void 0 ? 'button' : _type, rest = Button_objectWithoutProperties(_param, [
        "anchor",
        "appearance",
        "autoFocus",
        "children",
        "className",
        "iconAfter",
        "iconBefore",
        "isDisabled",
        "isLoading",
        "kind",
        "shape",
        "size",
        "testId",
        "type"
    ]);
    var buttonRef = (0,react.useRef)();
    var refs = (0,hooks/* useCombineRefs */.he)(buttonRef, ref);
    var classNames = (0,functions.classnames)('button', "button--".concat(kind, "-").concat(appearance), "button--shape-".concat(shape), "button--size-".concat(size), className);
    (0,react.useEffect)(function() {
        if (autoFocus && buttonRef.current) {
            buttonRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var renderContent = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                children && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "button-text",
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Y\xfckleniyor"
                })
            ]
        }));
    };
    return anchor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(anchor_Anchor, Button_objectSpread({
        className: classNames,
        "data-testid": testId
    }, anchor)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", Button_objectSpread({
        ref: refs,
        className: classNames,
        "data-testid": testId,
        type: type,
        disabled: isDisabled,
        tabIndex: isDisabled ? -1 : 0
    }, rest, {
        children: renderContent()
    }));
};
/* harmony default export */ var button_Button = (/*#__PURE__*/react.forwardRef(Button));


/***/ }),

/***/ 5664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ButtonGroup": function() { return /* reexport */ ButtonGroup; },
  "IconButton": function() { return /* reexport */ button_IconButton; },
  "default": function() { return /* reexport */ Button/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/base/button/ButtonGroup.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ButtonGroup = function(_param) {
    var children = _param.children, className = _param.className, rest = _objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: (0,functions.classnames)('button-group', className)
    }, rest, {
        children: children
    })));
};


// EXTERNAL MODULE: ./components/base/button/Button.tsx + 2 modules
var Button = __webpack_require__(8106);
;// CONCATENATED MODULE: ./components/base/button/IconButton.tsx



function IconButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IconButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            IconButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function IconButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = IconButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function IconButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IconButton = function(_param, ref) {
    var children = _param.children, rest = IconButton_objectWithoutProperties(_param, [
        "children"
    ]);
    if (/*#__PURE__*/ react.isValidElement(children)) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, IconButton_objectSpread({
            className: "button--icon",
            iconBefore: children,
            ref: ref
        }, rest)));
    }
    return null;
};
/* harmony default export */ var button_IconButton = (/*#__PURE__*/react.forwardRef(IconButton));

;// CONCATENATED MODULE: ./components/base/button/index.tsx





/***/ }),

/***/ 8117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sg": function() { return /* reexport */ column_Column; },
  "W2": function() { return /* reexport */ container_Container; },
  "X2": function() { return /* reexport */ row_Row; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
;// CONCATENATED MODULE: ./components/base/gridview/container/Container.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Container = function(_param) {
    var children = _param.children, className = _param.className, _size = _param.size, size = _size === void 0 ? 'wide' : _size, rest = _objectWithoutProperties(_param, [
        "children",
        "className",
        "size"
    ]);
    var classNames = (0,functions.classnames)('container', "container-".concat(size), className);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", _objectSpread({
        className: classNames
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var container_Container = (Container);

;// CONCATENATED MODULE: ./components/base/gridview/container/index.tsx


;// CONCATENATED MODULE: ./components/base/gridview/row/Row.tsx


function Row_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Row_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Row_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Row_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Row_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Row_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Row = function(_param) {
    var className = _param.className, xs = _param.xs, sm = _param.sm, md = _param.md, lg = _param.lg, xl = _param.xl, align = _param.align, content = _param.content, direction = _param.direction, gutter = _param.gutter, justify = _param.justify, wrap = _param.wrap, children = _param.children, testId = _param.testId, rest = Row_objectWithoutProperties(_param, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "align",
        "content",
        "direction",
        "gutter",
        "justify",
        "wrap",
        "children",
        "testId"
    ]);
    var classNames = {
        'row-align': align,
        'row-content': content,
        'row-direction': direction,
        'row-gutter': gutter,
        'row-justify': justify,
        'row-wrap': wrap
    };
    var createClassName = function(breakpoint) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        for(var prop in props){
            var value = props[prop];
            if (value) {
                classNames["row-".concat(breakpoint, "-").concat(prop)] = value;
            }
        }
    };
    createClassName('xs', xs);
    createClassName('sm', sm);
    createClassName('md', md);
    createClassName('lg', lg);
    createClassName('xl', xl);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", Row_objectSpread({
        className: (0,functions.classnames)('row', classNames, className),
        "data-testid": testId
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var row_Row = (Row);

;// CONCATENATED MODULE: ./components/base/gridview/row/index.tsx


;// CONCATENATED MODULE: ./components/base/gridview/column/Column.tsx


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function Column_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Column_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Column_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Column_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Column_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Column_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Column = function(_param) {
    var className = _param.className, xs = _param.xs, sm = _param.sm, md = _param.md, lg = _param.lg, xl = _param.xl, align = _param.align, offset = _param.offset, order = _param.order, size = _param.size, padding = _param.padding, auto = _param.auto, children = _param.children, testId = _param.testId, rest = Column_objectWithoutProperties(_param, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "align",
        "offset",
        "order",
        "size",
        "padding",
        "auto",
        "children",
        "testId"
    ]);
    var classNames = [
        'col'
    ];
    var createClassName = function(breakpoint) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        for(var prop in props){
            var value = props[prop];
            if (value !== undefined) {
                if (prop === 'size') {
                    classNames.push("col".concat(breakpoint, "-").concat(value));
                } else {
                    classNames.push("col".concat(breakpoint, "-").concat(prop, "-").concat(value));
                }
            }
        }
    };
    createClassName('', {
        size: size,
        offset: offset,
        align: align,
        order: order
    });
    createClassName('-xs', xs);
    createClassName('-sm', sm);
    createClassName('-md', md);
    createClassName('-lg', lg);
    createClassName('-xl', xl);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", Column_objectSpread({
        className: functions.classnames.apply(void 0, _toConsumableArray(classNames).concat([
            className,
            auto && 'col-auto'
        ])),
        "data-testid": testId
    }, rest, {
        children: children
    })));
};
/* harmony default export */ var column_Column = (Column);

;// CONCATENATED MODULE: ./components/base/gridview/column/index.tsx


;// CONCATENATED MODULE: ./components/base/gridview/index.tsx





/***/ }),

/***/ 9617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iz": function() { return /* reexport */ AppContextProvider; },
  "qD": function() { return /* reexport */ useApp; }
});

// UNUSED EXPORTS: AppContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./core/contexts/app/context.tsx

var AppContext = /*#__PURE__*/ (0,react.createContext)(null);
var AppContextProvider = AppContext.Provider;
var useApp = function() {
    var app = (0,react.useContext)(AppContext);
    if (app) {
        return app;
    }
    throw new Error('useApp must be used within a AppContextProvider.');
};

;// CONCATENATED MODULE: ./core/contexts/app/index.tsx



/***/ }),

/***/ 6613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "he": function() { return /* reexport */ useCombineRefs; },
  "tT": function() { return /* reexport */ useVar; }
});

// UNUSED EXPORTS: getNavigatorInstance, getUserAgent, match, useBrowser, useChrome, useClone, useDolphin, useEdge, useFirefox, useGecko, useGoanna, useIE, useMI, useMac, useMobile, useMounted, useOpera, usePresto, useSafari, useTablet, useTrident, useWindows, useYandex

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./core/hooks/useClone.ts

function useClone(elem, props) {
    if (React.isValidElement(elem)) {
        return React.cloneElement(elem, props || {});
    }
    return null;
}

;// CONCATENATED MODULE: ./core/hooks/useCombineRefs.ts
function useCombineRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(intance) {
        refs.filter(function(ref) {
            return ref;
        }).forEach(function(ref) {
            if (typeof ref === 'function') {
                ref(intance);
            } else {
                ref.current = intance;
            }
        });
    };
}

;// CONCATENATED MODULE: ./core/hooks/useMounted.ts

function useMounted() {
    var ref = useState(false), mounted = ref[0], setMounted = ref[1];
    useEffect(function() {
        setMounted(true);
    }, []);
    return mounted;
}

;// CONCATENATED MODULE: ./core/hooks/useVar.ts

function useVar(initialValue) {
    var current = (0,react.useRef)(initialValue).current;
    return current;
}

;// CONCATENATED MODULE: ./core/hooks/index.ts







/***/ }),

/***/ 58:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ path_namespaceObject; }
});

// UNUSED EXPORTS: color

// NAMESPACE OBJECT: ./core/utils/path.ts
var path_namespaceObject = {};
__webpack_require__.r(path_namespaceObject);
__webpack_require__.d(path_namespaceObject, {
  "app": function() { return app; },
  "asset": function() { return asset; },
  "url": function() { return url; }
});

;// CONCATENATED MODULE: ./constants/enums.ts
var NodeEnv;
(function(NodeEnv) {
    NodeEnv["Development"] = "development";
    NodeEnv["Production"] = "production";
    NodeEnv["Test"] = "test";
})(NodeEnv || (NodeEnv = {}));

;// CONCATENATED MODULE: ./core/utils/path.ts

/**
 * The ``app`` function returns the fully qualified path to the app directory.
 * You may also use the ``app`` function to generate a fully qualified path
 * to a given file relative to the application directory.
 *
 * @param {string} pathname Added directory path
 * @returns {string}
 */ var app = function(context, pathname) {
    var origin = context.url || '/';
    if (!pathname || typeof pathname !== 'string') return origin;
    if (pathname.indexOf('http') === 0) {
        return pathname;
    }
    if (context.environment === NodeEnv.Production) {
        return "/".concat(pathname);
    }
    return "/".concat(context.key, "/").concat(pathname);
};
var url = function(context, pathname) {
    var origin = context.url || '/';
    if (context.environment === NodeEnv.Production) {
        return "".concat(origin, "/").concat(pathname);
    }
    return "".concat(origin, "/").concat(context.key, "/").concat(pathname);
};
var asset = function(context, path) {
    if (!path) return '';
    if (path.indexOf('http') !== -1) {
        return path;
    } else {
        return "".concat(context.cdn, "/").concat(path);
    }
};

;// CONCATENATED MODULE: ./core/utils/index.ts






/***/ }),

/***/ 2638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pathname_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
;// CONCATENATED MODULE: ./components/widgets/category-select/definations.ts
var categoryEnum = [
    {
        text: 'Se\xe7im Yapınız',
        value: '0'
    },
    {
        text: 'Atolye',
        value: 'atolye'
    },
    {
        text: '\xc7o\xe7uk Etkinlikleri',
        value: 'cocuk-etkinlikleri'
    },
    {
        text: 'Konser',
        value: 'konser'
    },
    {
        text: 'Opera Bale',
        value: 'opera-bale'
    },
    {
        text: 'Sergi',
        value: 'sergi'
    },
    {
        text: 'Sinema',
        value: 'sinema'
    },
    {
        text: 'S\xf6yleşi',
        value: 'soylesi'
    },
    {
        text: 'Tiyatro M\xfczikal',
        value: 'tiyatro-muzikal'
    },
    {
        text: 'Etkinlik \xd6nerileri',
        value: 'etkinlikler'
    }, 
];

// EXTERNAL MODULE: ./components/base/button/index.tsx + 2 modules
var base_button = __webpack_require__(5664);
// EXTERNAL MODULE: ./node_modules/react-loading-icons/dist/esm/index.js + 12 modules
var esm = __webpack_require__(5533);
;// CONCATENATED MODULE: ./components/widgets/category-select/category-select.tsx







var Category = function(param) {
    var image = param.image, title = param.title, desc = param.desc;
    var app = (0,contexts_app/* useApp */.qD)();
    var ref = (0,react.useState)(''), selectedOption = ref[0], setSelectedOption = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var handleClick = function() {
        setIsLoading(true);
        if (selectedOption) {
            window.location.href = "".concat(selectedOption);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "form background-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "form_container",
            style: {
                maxWidth: '400px'
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "form_logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://cdn.tga.net.tr/".concat(image === null || image === void 0 ? void 0 : image.src),
                                    alt: "",
                                    width: (image === null || image === void 0 ? void 0 : image.width) || 200,
                                    height: image === null || image === void 0 ? void 0 : image.height
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form_title",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            desc,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "input-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                    className: "form-style",
                                    style: {
                                        width: '100%'
                                    },
                                    onChange: function(e) {
                                        return setSelectedOption(e.target.value);
                                    },
                                    children: categoryEnum.map(function(item, key) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                            value: item.value,
                                            children: item.text
                                        }, key);
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    textAlign: 'center',
                                    marginTop: '50px'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Rings */._P, {
                                    stroke: "#4a90e2",
                                    strokeWidth: 4
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "form_button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button["default"], {
                                    appearance: "default",
                                    onClick: handleClick,
                                    children: "Se\xe7imi Kaydet"
                                })
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var category_select = (Category);

;// CONCATENATED MODULE: ./components/index.tsx



var Button = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 5664));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5664)
            ];
        }
    }
});
var Heading = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 884).then(__webpack_require__.bind(__webpack_require__, 1884));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1884)
            ];
        }
    }
});
var Html = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 791).then(__webpack_require__.bind(__webpack_require__, 9791));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9791)
            ];
        }
    }
});
var Image = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 244).then(__webpack_require__.bind(__webpack_require__, 5244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5244)
            ];
        }
    }
});
var Section = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 263).then(__webpack_require__.bind(__webpack_require__, 2263));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2263)
            ];
        }
    }
});
var SuggestionOpt = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(685)]).then(__webpack_require__.bind(__webpack_require__, 9685));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9685)
            ];
        }
    }
});
var SuggestionOtpConfirmation = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(580)]).then(__webpack_require__.bind(__webpack_require__, 1580));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1580)
            ];
        }
    }
});
var Workshop = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(885), __webpack_require__.e(351), __webpack_require__.e(631), __webpack_require__.e(846)]).then(__webpack_require__.bind(__webpack_require__, 1104));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1104)
            ];
        }
    }
});
var userForm = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(885), __webpack_require__.e(351), __webpack_require__.e(631), __webpack_require__.e(297)]).then(__webpack_require__.bind(__webpack_require__, 141));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(141)
            ];
        }
    }
});
var SuccessPage = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 591).then(__webpack_require__.bind(__webpack_require__, 8591));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8591)
            ];
        }
    }
});
var ProjectForm = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(246), __webpack_require__.e(844)]).then(__webpack_require__.bind(__webpack_require__, 9289));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9289)
            ];
        }
    }
});
var TkyfOpt = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(786)]).then(__webpack_require__.bind(__webpack_require__, 1786));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1786)
            ];
        }
    }
});
var TkyfUser = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(885), __webpack_require__.e(351), __webpack_require__.e(130)]).then(__webpack_require__.bind(__webpack_require__, 5130));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5130)
            ];
        }
    }
});
var TkySucces = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 54).then(__webpack_require__.bind(__webpack_require__, 2054));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2054)
            ];
        }
    }
});
var TkyfOptConfirmation = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(351), __webpack_require__.e(692)]).then(__webpack_require__.bind(__webpack_require__, 692));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(692)
            ];
        }
    }
});
function getter(name) {
    switch(name){
        case 'heading':
            return Heading;
        case 'html':
            return Html;
        case 'container':
            return gridview/* Container */.W2;
        case 'row':
            return gridview/* Row */.X2;
        case 'section':
            return Section;
        case 'column':
            return gridview/* Column */.sg;
        case 'button':
            return Button;
        case 'image':
            return Image;
        case 'section':
            return Section;
        case 'title-desc':
            return SuggestionOpt;
        case 'otp-confirmation':
            return SuggestionOtpConfirmation;
        case 'workshop-form':
            return Workshop;
        case 'user-form':
            return userForm;
        case 'category-select':
            return category_select;
        case 'success':
            return SuccessPage;
        case 'project-form':
            return ProjectForm;
        case 'tkyf-giris':
            return TkyfOpt;
        case 'tkyf-confirmation':
            return TkyfOptConfirmation;
        case 'tkyf-user':
            return TkyfUser;
        case 'tkyf-success':
            return TkySucces;
    }
};

;// CONCATENATED MODULE: ./core/render.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var render = function(component1, context) {
    var id = component1.id, name = component1.name, props = component1.props, refs = component1.refs, children = component1.children;
    if (name === 'view') {
        var view = context.page.views[id];
        if (view) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: view.map(function(component) {
                    return render(component, context);
                })
            }, id));
        }
    } else {
        var Component = getter(name);
        if (Component) {
            if (children.length) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, props, refs, {
                    children: children.map(function(child) {
                        return render(child, context);
                    })
                }), id));
            } else {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, props, refs), id));
            }
        }
        if (false) {}
    }
};
/* harmony default export */ var core_render = (render);

;// CONCATENATED MODULE: ./components/error/Error.tsx

var Error_Error = function(param) {
    var code = param.code, type = param.type, message = param.message;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "error",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "error-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: code
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "/images/wap-platform.svg",
                alt: "WAP Platform"
            })
        ]
    }));
};
/* harmony default export */ var error_Error = (Error_Error);

;// CONCATENATED MODULE: ./components/error/index.tsx


// EXTERNAL MODULE: ./core/utils/index.ts + 2 modules
var utils = __webpack_require__(58);
;// CONCATENATED MODULE: ./components/base/seo-meta/SeoMeta.tsx




var SeoMeta = function(param) {
    var _context = param.context, page = _context.page, settings = _context.settings, environment = _context.environment;
    var suffix = "- ".concat(settings.shortName);
    var title = page.metatags.title || "".concat(page.title, " ").concat(suffix);
    var description = page.metatags.description || title;
    var url = utils/* path.url */.E.url(environment, page.path);
    var renderTitle = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("title", {
            children: title
        });
    };
    var renderMetaDescription = function() {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "description",
            content: description
        }));
    };
    var renderMetaOg = function() {
        var ref, ref1;
        var opengraph = page.metatags.opengraph;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:title",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:description",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.description) || description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:site_name",
                    content: settings.title || settings.shortName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:image",
                    content: utils/* path.asset */.E.asset(environment, (opengraph === null || opengraph === void 0 ? void 0 : (ref = opengraph.image) === null || ref === void 0 ? void 0 : ref.src) || ((ref1 = page.image) === null || ref1 === void 0 ? void 0 : ref1.src))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:url",
                    content: url
                })
            ]
        }));
    };
    var renderMetaGoogle = function() {
        var ref, ref2;
        var opengraph = page.metatags.opengraph;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    itemProp: "name",
                    content: (opengraph === null || opengraph === void 0 ? void 0 : opengraph.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    itemProp: "image",
                    content: utils/* path.asset */.E.asset(environment, (opengraph === null || opengraph === void 0 ? void 0 : (ref = opengraph.image) === null || ref === void 0 ? void 0 : ref.src) || ((ref2 = page.image) === null || ref2 === void 0 ? void 0 : ref2.src))
                })
            ]
        }));
    };
    var renderMetaTwitter = function() {
        var ref, ref3, ref4;
        var twitter = page.metatags.twitter;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:title",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.title) || title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:site",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.site) || url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:description",
                    content: (twitter === null || twitter === void 0 ? void 0 : twitter.summary) || (twitter === null || twitter === void 0 ? void 0 : twitter.description) || description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "twitter:image:src",
                    content: utils/* path.asset */.E.asset(environment, (twitter === null || twitter === void 0 ? void 0 : (ref = twitter.summaryImage) === null || ref === void 0 ? void 0 : ref.src) || (twitter === null || twitter === void 0 ? void 0 : (ref3 = twitter.image) === null || ref3 === void 0 ? void 0 : ref3.src) || ((ref4 = page.image) === null || ref4 === void 0 ? void 0 : ref4.src))
                })
            ]
        }));
    };
    var renderMetaOptions = function() {
        var content = [];
        if (page.metatags.isNoIndex) {
            content.push('noindex');
        }
        if (page.metatags.isNoFollow) {
            content.push('nofollow');
        }
        if (!content.length) return null;
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "robots",
            content: content.join(',')
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            renderTitle(),
            renderMetaDescription(),
            renderMetaOg(),
            renderMetaGoogle(),
            renderMetaTwitter(),
            renderMetaOptions()
        ]
    }));
};
/* harmony default export */ var seo_meta_SeoMeta = (SeoMeta);

;// CONCATENATED MODULE: ./components/base/seo-meta/index.ts


;// CONCATENATED MODULE: ./core/contexts/popup/context.tsx


var PopupContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var PopupProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), popup = ref[0], setPopup = ref[1];
    var ref1 = (0,react.useState)({
        video: '',
        title: '',
        desc: '',
        image: ''
    }), popupData = ref1[0], setPopupData = ref1[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopupContext.Provider, {
        value: {
            popup: popup,
            popupData: popupData,
            setPopup: setPopup,
            setPopupData: setPopupData
        },
        children: children
    }));
};
var usePopup = function() {
    var popup = useContext(PopupContext);
    if (popup) {
        return popup;
    }
    throw new Error('useApp must be used within a AppContextProvider.');
};

;// CONCATENATED MODULE: ./core/contexts/popup/index.tsx


;// CONCATENATED MODULE: ./pages/[...pathname].tsx









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _pathname_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _pathname_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _pathname_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Page = function(_param1) {
    var error = _param1.error, context = _objectWithoutProperties(_param1, [
        "error"
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        if (context.language) {
            var cookie = new es6/* default */.Z();
            cookie.set('language', context.language);
        }
    }, [
        context
    ]);
    var renderColorPalette = function() {
        var _theme = context.theme, colors = _theme.colors, neutrals = _theme.neutrals;
        var getcss = function(name, tones) {
            var entries = Object.entries(tones);
            return entries.map(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                if (name.length == 2) {
                    return "--".concat(name).concat(key, ": ").concat(value, ";\n                    --").concat(name).concat(key, "-RGB: ").concat(value.replace(/[rgb|\(\)]/gm, ''), ";");
                }
                return "--".concat(name).concat(key, ": ").concat(value, ";");
            }).join('');
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
            type: "text/css",
            children: ":root {".concat([
                getcss('DN', neutrals.dark),
                getcss('LN', neutrals.light),
                getcss('PC', colors.primary),
                getcss('R', colors.red),
                getcss('Y', colors.yellow),
                getcss('G', colors.green),
                getcss('B', colors.blue),
                getcss('P', colors.purple),
                getcss('T', colors.teal), 
            ].join(''), "}")
        }));
    };
    var renderStyle = function() {
        var styles = context.settings.styles;
        if (styles) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                type: "text/css",
                children: styles
            }));
        }
    };
    var renderAlternates = function() {
        var alternates = context.page.alternates;
        if (alternates) {
            return alternates.map(function(param, index) {
                var title = param.title, href = param.href, hreflang = param.hreflang;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    title: title,
                    hrefLang: hreflang,
                    href: href
                }, index);
            });
        }
    };
    if (error) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(error_Error, _pathname_objectSpread({}, error)));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.StrictMode, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: context.page.title
                    }),
                    renderAlternates(),
                    renderColorPalette()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_meta_SeoMeta, {
                context: context
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contexts_app/* AppContextProvider */.iz, {
                value: context,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupProvider, {
                    children: context.page.layout.map(function(component) {
                        return core_render(component, context);
                    })
                })
            }),
            renderStyle()
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ var _pathname_ = (Page);


/***/ })

}]);